import { toast } from "react-toastify";
import { observable } from "mobx";
import { api, apiOperacao } from "../../api";
import { toast_error } from "../../utils";

export class _SitfisStore {
    obs = observable({
        selectedTab: "downloads" as string,
        tasks_sitfis: [] as any[],
        tasks_length: 0 as number,
        credito_usados: 0 as number,
        credito_contratado: 0 as number,
        qrcode: "" as string,
        pix_id: "" as string,
        loading: false as boolean,
        loading_solicitacao: false as boolean,
        loading_arquivos: false as boolean,
        loading_solicitacoes: false as boolean,
        erros_sitfis_auto: [] as any,
    })

    async handleTasksPaged(paged: number, cnpj: string) {
        try {
            let data = {
                page: paged,
                limit: 15,
                cnpj: cnpj
            }
            let resp = await apiOperacao("sitfis").post("/sitfis/index", data);

            this.obs.tasks_sitfis = [];
            this.obs.tasks_length = 0

            if (resp.data.itens.length == 0) {
                toast.warning('Nenhuma solicitação foi encontrada, tente novamente mais tarde.', {});
            } else {
                this.obs.tasks_sitfis = resp.data.itens;
                this.obs.tasks_length = resp.data.count;
            }

        } catch (ex) { }

        this.obs.loading_solicitacoes = false
    }

    async handleSolicitaSitfis(params: any) {
        this.obs.loading_solicitacao = true

        try {
            let resp = await apiOperacao("sitfis").post("/sitfis/create", params);

            if (resp.data.length == 0) {
                toast.success('Solicitação realizada com sucesso!', {});
                return []

            } else {
                toast.error("Infelizmente, não foi possível realizar a solicitação para algumas empresas.", {});
                return resp.data
            }
        } catch (ex) {
            toast_error(ex, `Erro ao realizar Solicitação, tente novamente mais tarde`);
            return []
        }
    }

    async handleConsultaCredito() {
        try {
            let resp = await apiOperacao("sitfis").get("/sitfis/free/credits");

            this.obs.credito_usados = resp.data.qtd_utilizada
            this.obs.credito_contratado = resp.data.qtd_contratada
        } catch (ex) {
            toast_error(ex, `Erro ao consultar Saldos, tente novamente mais tarde`);
        }
    }

    async handleBuyQuantidade(quantidade: number) {
        this.obs.loading = true

        try {
            let params = {
                quantidade: quantidade
            }
            let resp = await apiOperacao("sitfis").post("/sitfis/buy/credits", params);

            if (resp.data.ok) {
                this.obs.qrcode = resp.data.qrcode
                this.obs.pix_id = resp.data.pix_id
                this.obs.loading = false
                return true
            } else {
                toast.error(resp.data.msg, {});
                this.obs.loading = false
                return false
            }
        } catch (ex) {
            toast_error(ex, `Erro ao processar Compra, tente novamente mais tarde`);
            this.obs.loading = false
            return false
        }
    }

    async downloadArquivos(sitfis_id: string, cnpj: string) {
        this.obs.loading_arquivos = true

        try {
            let params = {
                id: sitfis_id
            }
            let resp = await apiOperacao("sitfis").post(`/sitfis/download`, params);

            if (resp.data.file) {
                const linkSource = `data:application/pdf;base64,${resp.data.file}`;
                const downloadLink = document.createElement("a");
                const fileName = cnpj + "_sitfis.pdf";
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                toast.error('Não foi possível realizar o download.', {});
            }
        } catch (ex) {
            toast_error(ex, `Erro Download Arquivo, tente novamente mais tarde`);
        }

        this.obs.loading_arquivos = false
    }

    async handleErrosAutomatico() {
        try {
            let resp = await apiOperacao("sitfis").get("/sitfis/erros/automatico");

            this.obs.erros_sitfis_auto = resp.data
        } catch (ex) {
            toast_error(ex, `Erro ao consultar Erros, tente novamente mais tarde`);
        }
    }

    async handleDeleteErros() {
        try {
            let resp = await apiOperacao("sitfis").get("/sitfis/erros/delete");

            if (resp.data.ok) {
                toast.success('Erros deletados com sucesso!', {});
            } else {
                toast.error("Não foi possível deletar, tente novamente mais tarde", {});
            }

        } catch (ex) {
            toast_error(ex, `Ocorreu um erro ao deletar, tente novamente mais tarde`);
        }
    }
}

export const SitfisStore = new _SitfisStore();
